module.exports = __webpack_public_path__ + "static/media/checkbox-on.e1ff0c66.svg";